import { createStore } from "vuex";
import Content from "./Content";
import FormList from "./FormList";
import csrApi from "../api/serve";

export default createStore({
    // plugins: [createLogger()],
    state: {
        nav: [],
        lang: "",
    },
    mutations: {
        saveNav(state, navData) {
            state.nav = navData;
        },
        setCurrentLang(state, data) {
            state.lang = data;
        },
    },
    actions: {
        async fetchMenu({ commit }, parameter) {
            try {
                const response = await csrApi.get(
                    `/menu?country_code=${parameter.lang}`
                );
                commit("saveNav", response.data.nav);
            } catch (err) {
                console.log(err);
            }
        },
    },
    getters: {
        getNavData(state) {
            return state.nav;
        },
        getCurrentLang(state) {
            return state.lang;
        },
    },
    modules: {
        Content,
        FormList,
    },
});
